<template>
  <div class="bullets-toc">
    <div class="list-unstyled bullets-toc__list">
      <a v-for="{ id, anchor, title } in chartsWithAnchors" :key="id" class="bullets-toc__list__item" href="#" v-scroll-to="anchor">
        <span class="bullets-toc__list__item__title">
          {{ title }}
        </span>
      </a>
    </div>
  </div>
</template>

<script>
import filter from 'lodash/filter'

export default {
  name: 'BulletsToc',
  props: {
    charts: {
      type: Array
    }
  },
  computed: {
    chartsWithAnchors () {
      return filter(this.charts, chart => !!chart.id)
    }
  }
}
</script>

<style lang="scss">
  @import '../variables.scss';

  .bullets-toc {
    display: inline-block;
    border-radius: 1rem;
    background: white;
    padding: 0;
    border: 1px transparent solid;

    &:hover {
      border-color: rgba($gray-200, 10%);
    }

    &__list {
      text-align: center;
      padding: .10rem 0;
      margin: 0;

      &__item {
        border-radius: 1rem;
        width: 1.5rem;
        height: 1.5rem;
        margin: .25rem;
        position: relative;
        background: $gray-300;
        cursor: pointer;
        display: block;

        &:hover {
          background: $primary;
        }

        &:hover &__title {
          display: flex;
        }

        &__title {
          white-space: nowrap;
          position: absolute;
          right: 50%;
          top: 50%;
          transform: translate(0, -50%);
          background: $primary;
          font-size: 0.8em;
          color: white;
          padding: 0;
          padding-left: .75rem;
          height: 1.5rem;
          display: none;
          flex-direction: column;
          justify-content: center;
          border-top-left-radius: inherit;
          border-bottom-left-radius: inherit;
        }
      }
    }
  }
</style>
